export enum SurveyType {
    All = -200,

    IndexSelection = 0,

    AiGenerate = 1,
}